<template>
  <div>
    <AppSignUpHeader
      :headerText="headerText"
      :headerBtn="true"
      :headerBack="reSameInput"
      @closeComponentEmit="closeComponentEmit"
      @reSameInputChange="reSameInputChange"
    />
    <div class="app-wrap">
      <ProgressBar v-if="visible">
        <template #text>비밀번호 설정</template>
        <template #step3>
          <div class="progress-on"></div>
        </template>
      </ProgressBar>
      <div class="keypad-group">
        <p v-if="(!reSameInput && visible) || isAuth">로그인시 사용할<br><span>간편비밀번호 숫자6자리를</span><br>입력해 주세요</p>
        <p v-else-if="!reSameInput && !visible">새롭게 사용하실<br><span>로그인 비밀번호</span>를 입력해주세요</p>
        <p v-else><span>동일하게 한번 더</span><br>숫자6자리를 입력해주세요</p>
        <KeyPad
          ref="pwd"
          class="keypad-input"
          :padSwitch="padSwitch"
          @firstPwd="firstPwd"
          @secondPwd="secondPwd"
        />
        <p v-show="confirmFaild" class="keypad-fail">{{ showResultMsg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import AppSignUpHeader from '@/components/Header/AppSignUpHeader.vue'
import ProgressBar from '@/components/SignUp/ProgressBar.vue'
import KeyPad from '@/components/Common/KeyPad.vue'
import service from '@/backend/modnpay_app_api'
import { THROW_APP_ERROR, THROW_APP_LOGIN_OVER_LAP } from '@/router'
import { SET_TEMP_USER_CODE } from '@/store/_actions/actionTypes'
/* eslint-disable eqeqeq */
export default {
  components: {
    AppSignUpHeader,
    ProgressBar,
    KeyPad
  },
  props: {
    visible: Boolean,
    shareData: Object
  },
  data () {
    return {
      passwd: '',
      confirmPasswd: '',
      padSwitch: true, // 비밀번호 input
      reSameInput: false, // 동일하게 한번 더
      confirmFaild: false,
      showResultMsg: ''
    }
  },
  created () {
    this.headerTextSwitch()
  },
  computed: {
    currentStoreCode () { return this.$store.getters.currentStoreCode },
    tempUserCode () {
      return this.$store.getters.tempUserCode
    }, 
    isAuth() {
      return !!localStorage.getItem('isAuth')
    }
  },
  methods: {
    reSameInputChange () {
      this.reSameInput = !this.reSameInput
      this.padSwitch = !this.padSwitch
    },
    headerTextSwitch () {
      if (this.visible) {
        this.headerText = '시작하기'
      } else {
        this.headerText = '비밀번호 변경'
      }
    },
    // 비밀번호 유효성체크
    async firstPwd (value) {
      const req = {
        /**
         * 2026-04-23
         * 회원가입 시 백엔드에서 앞자리 6 + 뒷자리 1 통해 나이 검사를 하기 때문에
         * props된 this.shareData.perNo를 6자리로 자름
         */
        perNo: this.shareData.perNo.slice(0, 6),
        passwd: value
      }

      const { data } = await service.passwordValidationCheck(req)
      const code = data.resultCode
      if (code == 0) {
        this.passwd = value
        this.padSwitch = false
        this.reSameInput = !this.reSameInput
        this.confirmFaild = false
      } else {
        this.confirmFaild = true
        this.showResultMsg = data.resultMsg
      }
      this.$refs.pwd.passwd = ''
    },
    // 비밀번호 일치 확인
    async secondPwd (value) {
      const req = {
        passwd: this.passwd,
        confirmPasswd: value
      }
      const { data } = await service.confirmPasswd(req)
      const code = data.resultCode
      // 회원가입
      if (code == 0 && (this.visible || localStorage.getItem('isAuth')) ) {
        this.enrollMember(value)
      } else if (code == 0 && !this.visible) {
        // 비밀번호 변경
        this.changePasswd(value)
      } else {
        this.confirmFaild = true
        this.showResultMsg = data.resultMsg
        this.$refs.pwd.confirmPasswd = ''
      }
    },
    // 회원가입
    async enrollMember (value) {
      const req = {
        deviceId: localStorage.getItem('deviceId'),
        userCode: this.tempUserCode,
        phone: this.shareData.phone,
        lastPhone: this.shareData.lastPhone,
        perNo: this.shareData.perNo,
        name: this.shareData.name,
        ci: this.shareData.ci,
        passwd: value,
        storeCode: this.$store.getters.LoginAuthFlag ? this.currentStoreCode : ''
      }

      const { data } = await service.enrollMember(req)
      const code = data.resultCode

      if (code == 0 || code == 20006) {
        localStorage.setItem('encPasswd', data.encPasswd)
        localStorage.setItem('ci', data.ci)
        localStorage.setItem('appUserCode', data.userCode)
        this.$store.commit(SET_TEMP_USER_CODE, '')
        this.appUpdateUserInfo(data.userCode, data.encPasswd, data.orderAppUser)
        this.login(value)
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    },
    // 비밀번호 변경
    async changePasswd (value) {
      const req = {
        userCode: '',
        passwd: value
      }

      const { data } = await service.changePasswd(req)
      const code = data.resultCode
      if (code == 0) {
        localStorage.setItem('encPasswd', data.encPasswd)
        this.closeComponentEmit()
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    },
    async login (value) {
      const req = {
        deviceId: localStorage.getItem('deviceId'),
        passwd: value
      }
      // 로그인 전 header에 인증 정보 제거
      const { data } = await service.appLogin(req)
      const code = data.resultCode

      if (code == 0) {
        // 정상 로그인 시 중복 로그인 플레그 제거
        localStorage.removeItem('isDuplicatdLogin')
        localStorage.setItem('Authorization', data.accessToken)
        localStorage.removeItem('isAuth')
        this.$emit('nextComponent', { componentName: 'AppSignUpFinPage' })
      } else {
        THROW_APP_ERROR()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
